import { render, staticRenderFns } from "./OptionTitle.vue?vue&type=template&id=763606fe"
import script from "./OptionTitle.vue?vue&type=script&lang=js"
export * from "./OptionTitle.vue?vue&type=script&lang=js"
import style0 from "./OptionTitle.vue?vue&type=style&index=0&id=763606fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
